import "./../areaChart.css";

import * as d3 from "d3";
import React, { useEffect } from "react";

interface AreaChartYAxisProps {
    yScale: d3.ScaleLinear<number, number>;
    mobile: boolean;
    tickFormat?: string;
    d3Id: string;
}

export const AreaChartYAxis = (props: AreaChartYAxisProps) => {
    const { yScale, mobile, tickFormat = "$", d3Id } = props;

    useEffect(() => {
        // create axis
        const yAxis = d3
            .axisLeft(yScale)
            .tickSize(0)
            .ticks(5)
            .tickFormat((x, i) => {
                //at first index, return 0
                if (i === 0) {
                    return `${tickFormat}0`;
                }
                //don't show if value is less than 1 whole unit
                if (x.valueOf() % 1 !== 0) {
                    return null;
                }
                //if value is greater than 1000, use alt formatting
                if (x.valueOf() >= 1000) {
                    return `${tickFormat}` + (+x / 1000).toString() + "k";
                }
                return `${tickFormat}` + (+x).toString();
            });
        {
            mobile
                ? null
                : // appending y axis and removing axis line
                  d3.select(`#${d3Id}`)
                      .selectAll(".y-axis")
                      .append("g")
                      .call(yAxis)
                      .select(".domain")
                      .remove();

            // customize y axis text
            d3.select(`#${d3Id}`)
                .selectAll(".y-axis text")
                .attr("transform", "translate(-5,0)")
                .style("text-anchor", "end")
                .attr("font-size", 6)
                .attr("font-weight", "normal")
                .style("fill", "#222222")
                .attr("font-family", "'hkgrotesk_regular'")
                .style("opacity", 0.8);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <g className="y-axis"></g>;
};
